import $ from 'jquery';

$(document).ready(function() {

  $('.vehicle_icon_link').click(function() {
    var type_id = $(this).attr('id');
    $('#vehicle_type').val(type_id);
    $('.vehicle_type_name').html($(this).attr('data-name'));
    $(".hd_fuel_id, .hd_type_"+type_id).prop("checked", true);
    $(".hd_fuel_id, .hd_type_"+type_id).closest('.fuel-select').show();
    $(".hd_fuel_id").not(".hd_type_"+type_id).prop("checked", false);
    $(".hd_fuel_id").not(".hd_type_"+type_id).closest('.fuel-select').hide();
    $('#heavy_all_fuels').prop("checked", true);

    $(document).on("keydown", function (e) {
      if ( e.keyCode == 13 ) {
        //check for return key
        $(".modal .btn-search").filter(":visible").trigger("click");
      }
    });
  });

  $('.hd_fuel_id').click(function() {
    if (!$(this).prop('checked')) {
      $('#heavy_all_fuels').prop('checked', false);
    }
    if ($(".hd_fuel_id:visible:checked").length == $(".hd_fuel_id:visible").length) {
      $('#heavy_all_fuels').prop('checked', true);
    }
  });

  $('.engine_fuel_id').click(function() {
    if (!$(this).prop('checked')) {
      $('#engine_all_fuels').prop('checked', false);
    }
    if ($(".engine_fuel_id:visible:checked").length == $(".engine_fuel_id:visible").length) {
      $('#engine_all_fuels').prop('checked', true);
    }
  });

  $('#heavy_duty_vehicle_categories_button').click(function() {
    if ($('#hd_manufacturer_id').val() == '') {
      var ids = [];
      $.each($("#hd_manufacturer_id option"), function(i, id) {
        if ($(id).val() != '') {
          ids.push($(id).val());
        }
      });
      window.location.href = "/vehicles/search/results?manufacturer_id="+ids.join(",");
    } else {
      window.location.href = "/vehicles/search/results?manufacturer_id="+$('#hd_manufacturer_id').val();
    }
  });

  $('#heavy_all_fuels').click(function() {
    if ($(this).prop('checked') == true) {
      $('input[name="heavy_fuel_ids[]"]').prop('checked', true);
    } else {
      $('input[name="heavy_fuel_ids[]"]').prop('checked', false);
    }
  });

  $('#engine_all_fuels').click(function() {
    if ($(this).prop('checked') == true) {
      $('input[name="engine_fuel_ids[]"]').prop('checked', true);
    } else {
      $('input[name="engine_fuel_ids[]"]').prop('checked', false);
    }
  });

  $('#heavy_search_button').click(function()   {
    if ( $(".hd_fuel_id:checked").length == 0 ) {
      alert("You must select at least one fuel.");
    } else {
      $('#heavy_all_fuels').attr("checked", true);
      $('#pick-heavy-duty-fuel').toggle();
      $('body').css('cursor', 'wait');
      var fuel_ids = '';
      $('input[name="heavy_fuel_ids[]"]:checked').each(function() {
        fuel_ids += this.value+ ',';
        $(this).attr("checked", true);
      });
      var all_checked = $('#heavy_all_fuels:checked').length ? $('#heavy_all_fuels').val() : '';
      $('body').removeClass('modal-open');
      $('.modal-backdrop').remove();
      $('.vehicle_icon_link').css('background-color', 'transparent');
      $('body').css('cursor', 'pointer');
      $('#heavy_all_fuels').attr("checked", true);
      window.location.href = "/vehicles/search/results/?vehicle_type=heavy&category_id="+$('#vehicle_type').val()+ '&fuel_id=' + fuel_ids + '&all_fuels=' + all_checked;
    }
  });

  $('#engine_search_button').click(function() {
    if ( $(".engine_fuel_id:checked").length == 0 ) {
      alert("You must select at least one fuel.");
    } else {
      $('#pick-engine-fuel').toggle();
      $('body').css('cursor', 'wait');
      var fuel_ids = '';
      $('input[name="engine_fuel_ids[]"]:checked').each(function() {
        fuel_ids += this.value+ ',';
        $(this).attr("checked", true);
      });
      var all_checked = $('#engine_all_fuels:checked').length ? $('#engine_all_fuels').val() : '';
      $('#engine_all_fuels').attr("checked", true);
      $('body').removeClass('modal-open');
      $('.modal-backdrop').remove();
      $('.vehicle_icon_link').css('background-color', 'transparent');
      $('body').css('cursor', 'pointer');
      window.location.href = "/vehicles/search/engine_power_source/?fuel_id=" + fuel_ids+"&all_fuels="+all_checked;
    }
  });
});
